// extracted by mini-css-extract-plugin
module.exports = {"store-hours-info-text":"store-hours-info_store-hours-info-text__HOaTC"};